import { render, staticRenderFns } from "./CartPromoItem.vue?vue&type=template&id=01136790&scoped=true&lang=pug&"
import script from "./CartPromoItem.vue?vue&type=script&lang=js&"
export * from "./CartPromoItem.vue?vue&type=script&lang=js&"
import style0 from "./CartPromoItem.vue?vue&type=style&index=0&id=01136790&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01136790",
  null
  
)

export default component.exports